import { createModel } from '@rematch/core';
import type { RootModel } from 'models';
import { baseReducers, BaseState } from 'models/baseReducers';
import shippingService from 'services/shippingService';

import { CarrierTypeEnum, ValidatingAddress } from 'domains/shippingDomain';
import { OrgShippingCarrier, OrgShippingConfigDTO } from '../domains/orgDomain';

const { FedEx, UPS } = CarrierTypeEnum;

interface ShippingState extends BaseState {
  noMarkupCount: number;
  orgShippingConfig?: OrgShippingConfigDTO;
}

export const shipping = createModel<RootModel>()({
  state: {
    shippingConfig: undefined,
    noMarkupCount: 0,
    orgShippingConfig: undefined,
  } as ShippingState,
  reducers: {
    ...baseReducers<ShippingState>(),
    reset: (state: ShippingState) => {
      state.noMarkupCount = 0;
      state.orgShippingConfig = undefined;
      return state;
    },
  },
  effects: (dispatch) => {
    const { shipping } = dispatch;
    return {
      async getOrgShippingConfig(orgId: number): Promise<void> {
        const data = await shippingService.getOrgShippingConfig(orgId);
        const noMarkupCount = data.carriers.reduce((acc, curr) => {
          const { fedEx, ups, carrierType } = curr;
          if (
            (carrierType === FedEx && !fedEx?.markupPct) ||
            (carrierType === UPS && !ups?.markupPct)
          ) {
            return acc + 1;
          }
          return acc;
        }, 0);

        shipping.setState({
          orgShippingConfig: data,
          noMarkupCount,
        });
      },

      async saveOrgShippingCarrier(
        payload: OrgShippingCarrier & { orgId: number },
        state
      ): Promise<void> {
        const res = await shippingService.updateOrgShippingConfigCarrier(
          payload.orgId,
          payload
        );
        if (res) {
          const { orgShippingConfig } = state.shipping;
          const { serialNumber } = payload;
          const { carriers } = orgShippingConfig!;
          const index = carriers.findIndex(
            (carrier) => carrier.serialNumber === serialNumber
          );
          const carrierCopy = [...carriers];
          if (index > -1) {
            carrierCopy[index] = res;
            shipping.setState({
              orgShippingConfig: {
                ...orgShippingConfig!,
                carriers: carrierCopy,
              },
            });
          }
        }
      },

      async validateAddress(
        payload: ValidatingAddress
      ): Promise<ValidatingAddress[]> {
        return await shippingService.validateAddress(payload);
      },
    };
  },
});
